import { useNavigate, NavigateOptions, To } from 'react-router-dom';
import { useCurrentLanguage, getLocalizedPath } from 'utils/localizedRouting';

/**
 * A drop-in replacement for useNavigate that automatically prefixes relative paths
 * with the current language code (e.g. navigate('/') -> navigate('/ru')).
 */
export const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const currentLang = useCurrentLanguage();

  return (to: To | number, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      return navigate(to);
    }

    if (typeof to === 'string') {
      return navigate(getLocalizedPath(to, currentLang), options);
    }

    if (to && typeof to === 'object' && to.pathname) {
      return navigate(
        {
          ...to,
          pathname: getLocalizedPath(to.pathname, currentLang),
        },
        options,
      );
    }

    return navigate(to, options);
  };
};

export default useLocalizedNavigate;
